import { styled } from "theme/default/styled";

import { Input } from "../Input/Input.component";

export const SResetPasswordFormPasswordConfirm = styled(Input)`
  margin-bottom: 10px;
`;
